import React, {useState, useEffect} from 'react'
import {Box, Tooltip, AtlasButton} from '@fuegokit/react'
import {StyledRadixTooltipContent, StyledRadixTooltipArrow} from '../../../src/components/Tooltip/stories/StoryStyles'

const StyledTooltipExample = () => {
  const [domLoaded, setDomLoaded] = useState(false)

  useEffect(() => {
    setDomLoaded(true)
  }, [])
  return (
    <Box style={{display: 'flex', gap: 16}}>
      {domLoaded && (
        <Tooltip.Provider>
          <Tooltip>
            <Tooltip.Trigger asChild>
              <AtlasButton sx={{fontSize: 3}}>Hover or Focus me</AtlasButton>
            </Tooltip.Trigger>
            <Tooltip.Portal>
              <StyledRadixTooltipContent sideOffset={5}>
                Nicely done!
                <StyledRadixTooltipArrow offset={10} />
              </StyledRadixTooltipContent>
            </Tooltip.Portal>
          </Tooltip>
        </Tooltip.Provider>
      )}
    </Box>
  )
}
export default StyledTooltipExample
